export default __webpack_public_path__ + "static/media/goods8.a09d1a9c.gif";